<template>
    <div class="container-fluid welcome">
        <div class="container">
            <!--<div class="row">-->
                <!--<div class="col-md-6">-->
                    <!--<h1>{{ headingText }}</h1>-->
                    <!--<p> {{ para1 }}</p>-->
                    <!--<div class="hidden-xs hidden-sm">-->
                        <!--<p> {{ para2 }}</p>-->
                        <!--<p> {{ para3 }}</p>-->
                    <!--</div>-->
                    <!--<div>-->
                        <!--<router-link to="/jargon" class="home-btn"> {{ buttonText }} &#10095;</router-link>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="vcenter col-md-4">-->
                    <!--<img src="../assets/head.png" class="img-responsive">-->
                <!--</div>-->
            <!--</div>-->
            <div class="row">
                <div class="col-md-6 col-md-offset-1 col-sm-5 col-sm-offset-2 col-xs-11 vcenter">
                    <h1>{{ headingText }}</h1>
                    <p> {{ para1 }}</p>
                    <div class="hidden-xs hidden-sm">
                        <p> {{ para2 }}</p>
                        <p> {{ para3 }}</p>
                    </div>
                    <div class="hidden-xs" style="margin-top: 30px; margin-bottom: 30px;">
                        <router-link to="/jargon" class="home-btn"> {{ buttonText }} &#10095;</router-link>
                    </div>
                </div>
                <div class="hidden-md hidden-lg hidden-sm col-xs-4">
                    <router-link to="/jargon" class="home-btn"> {{ buttonText }} &#10095;</router-link>
                </div>
                <div class="hidden-xs col-sm-4 col-md-4 vcenter">
                    <img src="../assets/head.png" class="img-responsive">
                </div>


            </div>
            <div class="row">
                <div class="hidden-sm hidden-md hidden-lg col-xs-offset-6">
                    <img src="../assets/head.png" class="img-responsive">
                </div>
                <!---->
            </div>
        </div>
        <div class="article-link">
            <a target="_top" href="https://discover.dhl.com/business-matters/ecommerce/e-commerce-jargon-buster.html">https://discover.dhl.com/business-matters/ecommerce/e-commerce-jargon-buster.html</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Welcome',
        data() {
            return {
                headingText: "Making sense of commerce",
                para1: "In commerce, we all use jargon. But do we understand everything that we should? Explore our jargon buster and see which corners of commercial language need illuminating.",
                para2: "For instance, if you’ve heard phrases like ‘bonded goods’ and ‘multi-step checkout’ and sort of known what they refer to, here’s your chance to be absolutely certain.",
                para3: "We’ve included the definitions that we use, plus a layman’s version, to help everyone understand exactly what we mean.",
                buttonText: "Start here"
            }
        },
        mounted: function () {
            // let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            // $(".welcome").css('width', width + "px");
            // this.$nextTick(function () {
            //     $(window).resize(function () {
            //         let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            //         $(".welcome").css('width', width + "px");
            //     }).resize();
            // });
            $("a").on("click touchend", function (e) {
                let el = $(this);
                let link = el.attr("href");
                window.location = link;
            });
        }
    }

</script>
<style lang="scss" scoped>

    /* Extra Small Devices, Phones */
    @media only screen and (min-width: 320px) {
        .container {
            padding-left: 0;
            padding-right: 0;
        }
        .welcome {
            background: url('../assets/mobile-background.png') no-repeat -300px -160px;
            height: 440px;
            width: 100%;
            position: relative;
            h1 {
                font-size: 36px;
                @media only screen and (min-width: 1024px) {
                    font-size: 55px;
                }
            }
            @media only screen and (min-width: 768px) {
                height: 600px;
                background: url('../assets/background.jpg') no-repeat;
                background-size: 2560px 600px;
                vertical-align: middle;
                .container{
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
            @media only screen and (min-width: 1024px) {
                background: url('../assets/background.jpg') no-repeat;
                background-size: 2560px 600px;
            }

        }
        @media only screen and (min-width: 1200px) {
            text-align: left;
            height: 600px;
            width: 100%;
        }
    }

    .vcenter {
        display: inline-block;
        vertical-align: middle;
        float: none;
    }

    h1 {
        color: #FFCC00;
        text-transform: uppercase;
    }

    p {
        color: white;
    }

    a {
        color: white;
    }

    .img-responsive {
        position: relative;
        @media only screen and (max-width: 768px) {
            max-width: 70%;
            top: -40px;
        }
        @media only screen and (max-width: 480px) {
            top: -35px;
            max-width: 80%;
        }
    }

    a.home-btn {
        background-color: #D40511;
        border: 0;
        height: 35px;
        line-height: 26px;
        width: 170px;
        text-align: center;
        color: white;
        text-decoration: none;
        font-size: 16px;
        padding: 5px 15px 5px 15px;
        border-radius: 5px;
        display: inline-block;
    }

    .article-link {
        position: absolute;
        bottom: 20px;
        font-size: 10px;
        width: 99%;
        text-align: center;
        @media only screen and (max-width: 480px) {
            width: 60%;
            text-align: left;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue